// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useState} from 'react';
import {App_context} from 'hola_app_context';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {backend_url} from 'pub_config';
import zdate from '/util/date.js';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import {t_use_cp} from './use_cp';
import zutil from 'zutil';
import {Select} from '../../lib/select';
import {Datetime} from '../../lib/datetime';

import styles from './cp_profile.module.less';

type t_cp_profile_props = Partial<Pick<t_use_cp, 'back_btn' | 'is_mobile'>>;

const gender_list = {
    other: 'Other',
    male: 'Male',
    female: 'Female',
};

const cached_values: Record<string, string> = {};

const use_profile_field =
(field_name: string, to_server: (val: string)=>unknown, is_mobile: boolean)=>{
    const ctx = useContext(App_context);
    const server_value = cached_values[field_name]
      || ctx.user?.profile?.[field_name] || '';
    const [input_value, set_input_value] = useState(server_value);
    const [is_loading, set_is_loading] = useState(false);
    const on_save_to_server = (next: string)=>{
        return etask(function*(){
            try {
                set_is_loading(true);
                yield fetch(backend_url+ '/users/set_profile', {
                    method: 'POST',
                    body: {[field_name]: to_server(next)},
                });
                cached_values[field_name] = next;
            } catch {
                set_input_value(server_value);
            } finally {
                set_is_loading(false);
            }
        });
    };

    const on_choose = (next: string)=>{
        set_input_value(next);
        if (is_mobile)
            on_save_to_server(next);
    };

    return {
        value: input_value,
        disabled: is_loading || input_value == server_value,
        on_choose,
        on_save: ()=>on_save_to_server(input_value),
    };
};

export const CP_profile = (props: t_cp_profile_props)=>{
    const {back_btn, is_mobile} = props;
    const ctx = useContext(App_context);
    const email = zutil.get(ctx.user, 'emails.0.value') || '';
    const hola_uid = ctx.user?.hola_uid || '';
    const {theme} = React.useContext(Settings_context);
    const birthday = use_profile_field('birthday',
        v=>zdate.strftime('%Y-%m-%d', new Date(v)), is_mobile);
    const gender = use_profile_field('gender', v=>v, is_mobile);
    const max_year = new Date().getFullYear();
    const min_year = max_year - 100;

    return <div className={cn(styles.content, styles.profile)}>
      <h1 className={styles.title}>{back_btn}My profile</h1>
      <section className={styles.section}>
        <h2 className={styles.section_title}>My account</h2>
        <p className={theme.p3}>{email}</p>
      </section>
      <section className={styles.section}>
        <h2 className={styles.section_title}>Account ID</h2>
        <p className={theme.p3}>{hola_uid}</p>
      </section>
      <section className={styles.section}>
        <h2 className={styles.section_title}>Personal details</h2>
        <div className={cn(styles.input_line, styles.gender,
          !gender.value && styles.empty)}>
          <div className={styles.input}>
            <Select label="Gender" items={gender_list} title="Choose"
              on_select={(n, v)=>gender.on_choose(v)} value={gender.value}
              class_name={styles.gender_select} icon={null} size="md" />
          </div>
          {!is_mobile && <button className={styles.save}
            disabled={gender.disabled} onClick={gender.on_save}>
            Save
          </button>}
        </div>
        <div className={cn(styles.input_line, styles.birthday,
          !birthday.value && styles.empty)}>
          <div className={styles.input}>
            <Datetime label="Date of birth" value={birthday.value}
              on_change={birthday.on_choose} cls={styles.birthday_picker}
              min_year={min_year} max_year={max_year}
              no_margin dateonly icon={null} placeholder="mm/dd/yyyy"/>
          </div>
          {!is_mobile && <button className={styles.save}
            disabled={birthday.disabled} onClick={birthday.on_save}>
            Save
          </button>}
        </div>
      </section>
    </div>;
};
